import { FormControl, FormLabel } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Field } from "features/admin/Products/types";
import { useStyles } from "../InputFields/styles";
import styled from "styled-components/macro";
import ImageField, { Content } from "../InputFields/ImageField";
interface ProductImagesFieldsProps {
  item: Field;
  control: any;
  reset: boolean | undefined;
  setValue: any;
}

const ProductImagesFields: React.FC<ProductImagesFieldsProps> = ({
  item,
  control,
  reset,
  setValue,
}) => {
  const classes = useStyles();
  const [images, setImages] = useState<Content[]>([]);

  useEffect(() => {
    setImages(createImageState(10, item.value));
  }, []);

  useEffect(() => {
    if (reset !== undefined) {
      setImages(createEmptyImages(10));
    }
  }, [reset]);

  const createEmptyImages = (length: number) => {
    let count = 0;
    let arr: any[] = [];
    while (count < length) {
      arr.push(createEmptyImage(count));
      count++;
    }
    return arr;
  };

  const createEmptyImage = (id: number) => {
    return {
      id: id,
      name: item.name + id,
      file_name: undefined,
      contentType: undefined,
      image: undefined,
      is_main_image: false,
    };
  };

  const createImageState = (length: number, res?: Content[]) => {
    let temp: Content[] = [];
    if (res) {
      let index = 0;
      while (index < length) {
        let content: Content;
        if (res[index]) {
          content = {
            id: index,
            name: item.name + index,
            file_name: res[index].file_name,
            contentType: res[index].contentType,
            image: res[index].image,
            is_main_image: res[index].is_main_image,
          };
        } else {
          content = createEmptyImage(index);
        }
        temp.push(content);
        index++;
      }
    } else {
      return createEmptyImages(length);
    }

    return temp;
  };

  const renderFields = () => {
    return images.map((image, idx) => {
      return (
        <ImageField
          content={image}
          key={idx}
          control={control}
          reset={reset}
          required={idx === 0}
          setValue={setValue}
        />
      );
    });
  };
  return (
    <FormControl required={item.required} className={classes.formControl}>
      <ButtonsContainer>
        <FormLabel required={item.required}>{`Снимки на продукта`}</FormLabel>
      </ButtonsContainer>
      <Images>{renderFields()}</Images>
    </FormControl>
  );
};

const ButtonsContainer = styled.div`
  display: inline-flex;
  margin: 10px 0;
  align-items: center;
`;
const Images = styled.div`
  flex: 1;
  flex-flow: row wrap;
`;

export default ProductImagesFields;
